import React, { ReactNode } from 'react';

import styles from './Title.module.css';

export function Title(props: TitleProps) {
  const { title = '', subtitle = null } = props;

  if (!title) {
    return null;
  }
  return (
    <div className={styles.titleComponent}>
      <h5 data-test="section-title" className={styles.title}>
        {title}
      </h5>
      <div className={styles.subTitle}>{subtitle}</div>
    </div>
  );
}

export interface TitleProps {
  title?: string;
  subtitle?: ReactNode;
}

export default Title;
